import PartialReceptionConfirmationDialog from "@/components/dialogs/PartialReceptionConfirmationDialog";
import ActionButton from "@/components/loader-button/ActionButton";
import PartialReceptionSummary from "@/components/partial-reception/PartialReceptionSummary";
import RefusedArticleList from "@/components/partial-reception/RefusedArticleList";
import RefusedArticleScanner from "@/components/partial-reception/RefusedArticleScanner";
import ReturnHeader from "@/components/return/ReturnHeader";
import { Button } from "@/components/ui/button";
import { Toaster } from "@/components/ui/toaster";
import { usePartialReception } from "@/hooks/usePartialReception";
import { ScanBarcode } from "lucide-react";
import React from "react";

const PartialReceptionValidationPage: React.FC = () => {
  const {
    return_,
    isAllowedRole,
    counts,
    refusedArticles,
    isReadOnly,
    isReceived,
    hasBL,
    isValidating,
    isConfirmationOpened,
    startEditing,
    openConfirmation,
    setIsConfirmationOpened,
    handleScan,
    handleRemove,
    handleReception,
    handleBLDownload,
    handleBLJoin,
  } = usePartialReception();

  if (!isAllowedRole) {
    return null;
  }

  return (
    <div className="flex flex-col h-full min-h-0 gap-4 overflow-hidden">
      <div className="flex-shrink-0">
        <ReturnHeader return_={return_} />
      </div>

      {!isReadOnly && (
        <div className="flex-shrink-0">
          <RefusedArticleScanner onScan={handleScan} />
        </div>
      )}

      <div className="flex-shrink-0">
        <PartialReceptionSummary counts={counts} />
      </div>

      {isReadOnly && (
        <div className="px-4 flex-shrink-0">
          <Button variant="outline" className="w-full" onClick={startEditing}>
            <ScanBarcode className="mr-2 h-4 w-4" />
            Scanner ou retirer des articles refusés
          </Button>
        </div>
      )}

      <div className="px-4 flex flex-1 min-h-0 flex-col">
        <RefusedArticleList
          refusedArticles={refusedArticles}
          isReadOnly={isReadOnly}
          onRemove={handleRemove}
        />
      </div>

      <div className="px-4 flex flex-shrink-0 space-x-4 flex-row">
        <ActionButton
          loading={false}
          disabled={counts.total === 0 || isValidating}
          handleClick={openConfirmation}
          label="Terminer le contrôle"
        />
      </div>

      <PartialReceptionConfirmationDialog
        isOpened={isConfirmationOpened}
        setIsOpened={setIsConfirmationOpened}
        counts={counts}
        isLoading={isValidating}
        isReceived={isReceived}
        hasBL={hasBL}
        handleReception={handleReception}
        handleBLDownload={handleBLDownload}
        handleBLJoin={handleBLJoin}
      />
      <Toaster />
    </div>
  );
};

export default PartialReceptionValidationPage;
